export const zoneCaptureColumns = [

    {
        name: "Pickup Time",
        selector: (row) => row["pickUpDateTime"],
        sortable: true,

    },
    {
        name: "Trip End Time",
        selector: (row) => row["tripEndTime"],
        sortable: true,

    },
    {
        name: "Zone Name",
        selector: (row) => row["zone"],
        sortable: true,

    },
    {
        name: "Cab No",
        selector: (row) => row["cabNumber"],
        sortable: true,

    },
    {
        name: "Driver Mobile No",
        selector: (row) => row["driverMobile"],
        sortable: true,
        // center: true,
        // width: "150px"
    },
    {
        name: "Driver Name",
        selector: (row) => row["driverName"],
        sortable: true,
        // center: true,
        // width: "150px"
    },
    {
        name: "Booking No",
        selector: (row) => row["bookingId"],
        sortable: true,

    },
    {
        name: "Trip Status",
        selector: (row) => row["tripStatus"],
        sortable: true,

    },
    // {
    //     name: "Agent Name",
    //     selector: (row) => row["agentName"],
    //     sortable: true,

    // },
   
];